import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import PixelBlast from './components/PixelBlast';
import Home from './components/Home';
import CAViewer from './components/CAViewer';
import MyLinks from './components/MyLinks';
import './App.css';
import '@solana/wallet-adapter-react-ui/styles.css';

function App() {
  // Custom RPC endpoint
  const endpoint = useMemo(() => 'https://solana-mainnet.core.chainstack.com/292825e8adf618ccdedb8585b66a2218', []);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <Router>
            <div className="App">
              <div className="background-wrapper">
                <PixelBlast
                  variant="square"
                  pixelSize={4}
                  color="#B19EEF"
                  patternScale={2}
                  patternDensity={1}
                  pixelSizeJitter={0}
                  enableRipples
                  rippleSpeed={0.4}
                  rippleThickness={0.12}
                  rippleIntensityScale={1.5}
                  liquid={false}
                  liquidStrength={0.12}
                  liquidRadius={1.2}
                  liquidWobbleSpeed={5}
                  speed={0.5}
                  edgeFade={0.25}
                  transparent
                />
              </div>
              <div className="content-wrapper">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/ca/:uuid" element={<CAViewer />} />
                  <Route path="/my-links/:wallet" element={<MyLinks />} />
                </Routes>
              </div>
            </div>
          </Router>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;
